window.addEventListener("load", (event) => {
    const tabElements = document.querySelectorAll('.tab');

    tabElements.forEach(tab => {

        const tabButtons = tab.querySelectorAll('.tab__control-item');
        const tabContents = tab.querySelectorAll('.tab__content');
        const sliderButtons = tab.querySelectorAll('.tabs-slider__buttons-item');

        function removeActive(ar) {
            ar.forEach(element => {
                element.classList.remove('active');
            });
        }

        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                if (!button.classList.contains('active')) {
                    let index = [...tabButtons].indexOf(button);
                    let currentContent = [...tabContents][index];

                    if (sliderButtons.length) {
                        let blockId = button.getAttribute('block-id');
                        removeActive(sliderButtons);
                        document.querySelector(`.tabs-slider__buttons .${blockId}`).classList.add('active');
                    }
                    
                    removeActive(tabButtons);
                    removeActive(tabContents);

                    button.classList.add('active');
                    currentContent.classList.add('active');

                }
            })
        });

    });
});